import { REDIRECT_URL } from './constants';

const fdRedirectTo = () => {
    window.open(REDIRECT_URL, '_blank');
};

const getFdCarouselContent = (content) => {
    const data = content;

    return data.map(({ name, returns, icon, bg }, index) => {
        return {
            id: index,
            icon: icon,
            title: name,
            details: [
                {
                    label: 'Returns upto',
                    value: `${returns} <span class="p5-medium text-gray-500">p.a</span>`,
                },
            ],
            bg,
        };
    });
};

export { fdRedirectTo, getFdCarouselContent };
